export default "__VITE_ASSET__28b06849__"